import "../utility/lang-switcher";
import screenfull from "screenfull";
import "keen-slider/keen-slider.min.css";
import KeenSlider from "keen-slider";
import jsCookie from "js-cookie";


let youOnlyLookOnceTitle = document
	.getElementById("title")
	.getElementsByTagName("h1");

if (document.body.clientWidth <= 1135) {
	for (title in youOnlyLookOnceTitle) {
		if (!youOnlyLookOnceTitle[title].getBoundingClientRect) {
			continue;
		}
		youOnlyLookOnceTitle[title].style.opacity = 1;
	}
}else {
	document.body.onmousemove = updateTitleOpacity;
}
noise.seed(Math.random());

// let go_back_button = document.getElementById("go-back");
// go_back_button.herf = document.referrer;
// go_back_button.onclick = function() {
//     history.back();
//     return false;
// }

function updateTitleOpacity(event) {
	for (title in youOnlyLookOnceTitle) {
		var elem = youOnlyLookOnceTitle[title];
		if (!elem.getBoundingClientRect) {
			continue;
		}
		var elemCenter = {
			x: elem.getBoundingClientRect().left + elem.clientWidth / 2,
			y: elem.getBoundingClientRect().top + elem.clientHeight / 2,
		};
		// clientX is mouseX
		// offsetY is for relative position
		var dist = Math.sqrt(
			Math.abs(elemCenter.x - event.clientX) ** 2 +
				Math.abs(elemCenter.y - event.clientY) ** 2
		);
		var maxDist =
			Math.min(document.body.clientWidth, document.body.clientHeight) / 7;
		elem.style.opacity =
			Math.max(0, 0.9 - dist / maxDist) +
			noise.simplex2(event.clientX / 1000, event.clientY / 1000) / 10 +
			0.1;
	}
}

document.querySelector(".yolo-fullscreen").onclick = () => {
	if (screenfull.isEnabled) {
		screenfull.toggle();
	}
};

const imgCount = 175;
const imgUrlBase = "/yolo/yolo-";
const imgWidth = [1600];
const imgUExt = ".jpg";

const drip_sound_count = 12;
const drip_sound_url = "/yolo/drip_sound/drip";
const soundExt = ".wav";

let drip_audio = []
for (let i = 0; i < drip_sound_count; i++) {
	let s_url = `${drip_sound_url}-${i + 1}${soundExt}`;
	drip_audio.push(new Audio(s_url));
	drip_audio[i].volume = 1.0;
}

function playDrip() {
	drip_audio[Math.floor(Math.random() * drip_sound_count)].play();
}

function modifyDOM(s, abs, rel, vis) {
	s.slides[rel].innerHTML = ""; // remove old image

	let newImg = document.createElement("img");
	let srcsetStr = ``;
    let defaultSrc = `${imgUrlBase}1600-${abs + 1}${imgUExt}`;
	for (i in imgWidth) {
		srcsetStr += `${imgUrlBase}${imgWidth[i]}-${abs + 1}${imgUExt} ${imgWidth[i]}w, `;
	}
	// console.log(srcsetStr);
	// console.log(defaultSrc);
    newImg.draggable = false;
	newImg.srcset = srcsetStr;
	newImg.src = defaultSrc;
	if (!vis) {
		newImg.style.opacity = 0; // load but not show
	}
	s.slides[rel].append(newImg); // add new image
    console.log(`loading new img ${abs + 1}`);
}


function loadImages(s) {
	const curAbs = s.track.details.abs + start_pos;
	const curRel = s.track.details.rel;

	const nextAbs = s.track.details.abs + 1 + start_pos;
	// console.log(`nextAbs ${nextAbs}`);
	const nextRel = (curRel + 1) % 2;
	// console.log(`curRel ${curRel} nextRel ${nextRel}`);

	if (s.track.details.abs === 0) {
		modifyDOM(s, curAbs, curRel, true);
	}
    modifyDOM(s, nextAbs, nextRel, false);

	jsCookie.set("yolo-viewed-abs", curAbs, { expires: 10000 });
	// console.log(`cookie_set: ${curAbs}`);

}

function navigation(s) {
	let arrowRight;
	function arrowMarkup() {
		arrowRight = document.querySelector(".yolo-advance");
		arrowRight.addEventListener("click", () => {
			if (s.track.details.abs+start_pos  === imgCount - 1) {
				// since navigation is created before cookie is loaded,
				// this is to prevent the user from going to the next slide
				// if all the images are viewed
				updateClasses();
				return;
			}
			s.next();
			playDrip();
		});
	}

	function updateClasses() {
		var currSlide = s.track.details.abs;
		currSlide+start_pos === imgCount - 1
			? arrowRight.classList.add("arrow--disabled")
			: arrowRight.classList.remove("arrow--disabled");
	}

	s.on("created", () => {
		arrowMarkup();
		updateClasses();
	});
	s.on("slideChanged", () => {
		updateClasses();
	});
}

let start_pos = 0;
let slider = new KeenSlider(
	"#my-slider",
	{
		initial: 0,
		loop: true,
		drag: false,
		detailsChanged: (s) => {},
		animationEnded: (s) => {
			loadImages(s);
			setTimeout(() => {
				// make img visible
				s.slides[s.track.details.rel].querySelector("img").style.opacity = 1;
			}, 100);
		},
		created: (s) => {
			console.log("created");
			let storedAbs = jsCookie.get("yolo-viewed-abs");
			// console.log(`stored_view_pos = ${storedAbs}`);
			if ( storedAbs != undefined) {
				start_pos = parseInt(storedAbs);
			}
			loadImages(s);
		},
		slides: {
			number: 2,
			perView: 1,
		},
	},
	[navigation]
);
